import './styles.css';

import { useTranslation } from 'react-i18next';
import NotificationIcon from 'components/shared/NotificationIcon';

const plural = (n, one, many) => (n > 1 ? many : one);

function NotificationSummaryCards({ counts, loading, filters, onSelectActionTab, onSelectInfoTab }) {
  const { t } = useTranslation();
  const c = counts || {};
  // Une seule carte sélectionnée : celle de la colonne choisie en dernier.
  const isActionCard = (tab) => filters.focus === 'actions' && filters.tab === tab;
  const isInfoCard = (info) => filters.focus === 'infos' && filters.info === info;

  const cards = [
    {
      mod: 'todo',
      icon: 'todo',
      n: c.actions_todo,
      label: plural(c.actions_todo, 'action à faire', 'actions à faire'),
      active: isActionCard('todo'),
      onClick: () => onSelectActionTab('todo'),
    },
    {
      mod: 'urgent',
      icon: 'urgent',
      n: c.actions_urgent,
      label: plural(c.actions_urgent, 'action urgente (retard, relance)', 'actions urgentes (retard, relance)'),
      active: isActionCard('urgent'),
      onClick: () => onSelectActionTab('urgent'),
    },
    {
      mod: 'unread',
      icon: 'bell',
      n: c.info_unread,
      label: plural(c.info_unread, 'information non lue', 'informations non lues'),
      active: isInfoCard('unread'),
      onClick: () => onSelectInfoTab('unread'),
    },
    {
      mod: 'done',
      icon: 'check',
      n: c.actions_treated,
      label: plural(c.actions_treated, 'action traitée', 'actions traitées'),
      active: isActionCard('done'),
      onClick: () => onSelectActionTab('done'),
    },
  ];

  return (
    <section className="notif-summary" aria-label={t('Résumé')}>
      {cards.map((k) => {
        const value = loading || k.n == null ? '–' : k.n;
        return (
          <button
            key={k.mod}
            type="button"
            className={`notif-summary-card notif-summary-card--${k.mod}`}
            aria-pressed={k.active}
            onClick={k.onClick}
          >
            <span className="notif-summary-card__icon">
              <NotificationIcon name={k.icon} size={24} />
              <span className="notif-summary-card__badge">{value}</span>
            </span>
            <span className="notif-summary-card__text">
              {t('Vous avez')}{' '}
              <strong>
                {value} {t(k.label)}
              </strong>
            </span>
          </button>
        );
      })}
    </section>
  );
}

export default NotificationSummaryCards;
